import { createValidators } from 'modules/forms'
import { i18nKeys } from '../../app.i18n'

export const coreValidators = createValidators(i18nKeys.validations)



// WEBPACK FOOTER //
// ./src/app/shared/form-utils/validators.ts